// import { checkDiff } from '../../../../../utils/formValidation/errorCheckingFunctions';
import {
    getCharMinMessage,
    getNumMaxMessage,
    getNumMinMessage,
    getReqMessage
} from '../../../../../utils/formValidation/errorMessageFunctions';
export const MIN_REASON_DETAILS_LENGTH = 7;
export const MAX_REASON_DETAILS_LENGTH = 500;
export const MINIMUM_AMOUNT = 0.01;
export const MAXIMUM_AMOUNT = 9999.99;
// export const validate = (newEntry, editType) => {
export const validate = (newEntry, requestReasonDetails, paymentMethodDetails) => {
    let newErrors = {};

    if (!newEntry.adviserId) {
        newErrors = {
            ...newErrors,
            adviserId: { error: true, message: getReqMessage('Adviser') }
        };
    }

    if (!newEntry.amount) {
        newErrors = {
            ...newErrors,
            amount: { error: true, message: getReqMessage('Amount') }
        };
    } else if (newEntry.amount < MINIMUM_AMOUNT) {
        newErrors = {
            ...newErrors,
            amount: {
                error: true,
                message: getNumMinMessage('Amount', MINIMUM_AMOUNT)
            }
        };
    } else if (newEntry.amount > MAXIMUM_AMOUNT) {
        newErrors = {
            ...newErrors,
            amount: {
                error: true,
                message: getNumMaxMessage('Amount', MAXIMUM_AMOUNT)
            }
        };
    }

    if (!newEntry.requestTypeId) {
        newErrors = {
            ...newErrors,
            requestTypeId: { error: true, message: getReqMessage('Request Type') }
        };
    } else if (
        newEntry.requestTypeId &&
        requestReasonDetails.length > 0 &&
        !newEntry.paymentReasonId
    ) {
        newErrors = {
            ...newErrors,
            paymentReasonId: { error: true, message: getReqMessage('Request Reason') }
        };
    }

    if (!newEntry.paymentMethodTypeId) {
        newErrors = {
            ...newErrors,
            paymentMethodTypeId: { error: true, message: getReqMessage('Payment Method Type') }
        };
    } else if (
        newEntry.paymentMethodTypeId &&
        paymentMethodDetails.length > 0 &&
        !newEntry.paymentMethodId
    ) {
        newErrors = {
            ...newErrors,
            paymentMethodId: { error: true, message: getReqMessage('Payment Method') }
        };
    }

    if (newEntry.reasonDetail.trim().length < MIN_REASON_DETAILS_LENGTH) {
        newErrors = {
            ...newErrors,
            reasonDetail: {
                error: true,
                message: getCharMinMessage('Reason Detail', MIN_REASON_DETAILS_LENGTH)
            }
        };
    }

    // TODO
    // if (editType === 'edit' && Object.keys(newErrors).length < 1) {
    //     newErrors = checkDiff(newEntry, initialRow);
    // }
    return newErrors;
};
